import { render, staticRenderFns } from "./class_manual_add.vue?vue&type=template&id=7b20c815&"
import script from "./class_manual_add.vue?vue&type=script&lang=js&"
export * from "./class_manual_add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports